/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 ./planet.gltf --transform
*/

import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { useGLTF } from "@react-three/drei";

export function Planet(props) {
  const { nodes, materials } = useGLTF("/planet-transformed.glb");
  const ref = useRef();

  useFrame((_, delta) => {
    // ref.current.rotation.x -= delta / 3;
    ref.current.rotation.y += delta * 0.04;
    ref.current.rotation.z += delta * 0.02;
    ref.current.rotation.x += delta * 0.05;
    ref.current.updateMatrixWorld();
  }, -2);
  return (
    <group {...props} dispose={null} ref={ref}>
      <mesh geometry={nodes.Icosphere.geometry} material={materials.Grass} />
      <mesh geometry={nodes.Icosphere_1.geometry} material={materials.Sand} />
      <mesh
        geometry={nodes.Dock.geometry}
        material={materials.Wood}
        position={[0.11, 0.45, 0.96]}
        rotation={[-1.91, -0.48, -2.98]}
        scale={[0.01, 0.04, 0.04]}
      />
      <mesh
        geometry={nodes.Water.geometry}
        material={materials.Water}
        scale={1.03}
      />
      <group
        position={[-1.05, -0.19, -0.03]}
        rotation={[1.38, 0.16, 1.61]}
        scale={0.03}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[0.03, 1.05, 0.2]}
        rotation={[0.17, -0.52, 0.05]}
        scale={0.03}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[0.11, -0.68, 0.9]}
        rotation={[-0.82, -0.83, -2.99]}
        scale={[0.05, 0.05, 0.04]}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[1, 0.46, 0.27]}
        rotation={[1.13, 0.22, -1.16]}
        scale={0.03}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[0.83, 0.25, -0.73]}
        rotation={[-1.11, 0.11, -0.92]}
        scale={0.03}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[0.84, 0.41, 0.64]}
        rotation={[0.52, -0.37, -0.94]}
        scale={[0.03, 0.03, 0.02]}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[0.79, 0.33, 0.76]}
        rotation={[0.93, -0.05, -0.85]}
        scale={[0.03, 0.03, 0.02]}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[0.88, 0.31, 0.65]}
        rotation={[1.02, -0.17, -0.94]}
        scale={[0.03, 0.03, 0.02]}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[0.9, 0.41, 0.56]}
        rotation={[0.14, -0.58, -1.12]}
        scale={[0.03, 0.03, 0.02]}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[-1.02, -0.32, -0.08]}
        rotation={[2.22, 0.25, 1.39]}
        scale={0.03}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[-1.11, -0.08, -0.24]}
        rotation={[1.29, 0.03, 1.75]}
        scale={0.03}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[-1.09, -0.16, -0.28]}
        rotation={[2.2, 0.33, 1.72]}
        scale={0.03}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[-1.05, -0.28, -0.32]}
        rotation={[3.09, 0.33, 1.41]}
        scale={0.03}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[-0.5, 0.48, 0.81]}
        rotation={[1.05, 0.04, 0.43]}
        scale={[0.04, 0.04, 0.03]}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[0.52, 0.71, 0.72]}
        rotation={[0.45, -0.32, -0.45]}
        scale={[0.04, 0.04, 0.03]}
      >
        <mesh geometry={nodes.Plane039.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane039_1.geometry} material={materials.White} />
      </group>
      <group
        position={[0.43, 0.73, 0.75]}
        rotation={[0.73, -0.16, -0.42]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.37, 0.83, 0.68]}
        rotation={[0.62, -0.12, -0.29]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.08, 0.99, 0.38]}
        rotation={[0.41, -0.09, -0.04]}
        scale={0}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.27, 1.01, 0.19]}
        rotation={[0.16, -0.05, -0.24]}
        scale={0}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.31, 0.99, 0.24]}
        rotation={[0.16, -0.05, -0.24]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.19, 1.04, 0.16]}
        rotation={[0.16, -0.05, -0.24]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[-0.47, 0.56, 0.77]}
        rotation={[0.94, -0.16, 0.4]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[-0.54, 0.59, 0.72]}
        rotation={[0.94, -0.16, 0.4]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.95, 0.59, 0.25]}
        rotation={[0.23, 0.04, -0.97]}
        scale={0}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.97, 0.56, 0.26]}
        rotation={[0.26, -0.05, -1.13]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.9, 0.65, 0.27]}
        rotation={[0.84, 0.44, -0.98]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.87, 0.71, 0.15]}
        rotation={[0.27, 0, -0.85]}
        scale={0}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.89, 0.68, 0.17]}
        rotation={[0.24, -0.03, -0.85]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.82, 0.77, 0.17]}
        rotation={[0.84, 0.44, -0.98]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.79, 0.4, -0.71]}
        rotation={[-0.13, 0.59, -1.13]}
        scale={0}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.82, 0.37, -0.69]}
        rotation={[-0.17, 0.57, -1.11]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.78, 0.45, -0.69]}
        rotation={[0.77, 0.71, -1.69]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.85, 0.36, -0.64]}
        rotation={[-0.17, 0.57, -1.11]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.1, -0.8, 0.81]}
        rotation={[0.53, -1.34, -1.8]}
        scale={0}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.09, -0.81, 0.8]}
        rotation={[0.11, -1.29, -2.21]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.08, -0.77, 0.83]}
        rotation={[2.16, -0.54, -0.12]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.13, -0.77, 0.83]}
        rotation={[1.17, -1.32, -1.18]}
        scale={0}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.21, -0.7, 0.87]}
        rotation={[1.01, -1.34, -1.33]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.11, -0.74, 0.85]}
        rotation={[2.16, -0.54, -0.12]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.06, -0.91, 0.69]}
        rotation={[-0.64, 0.03, -2.95]}
        scale={0}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[-0.06, -0.84, 0.76]}
        rotation={[-0.68, 0.15, 3.03]}
        scale={0}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.1, -0.89, 0.7]}
        rotation={[-0.32, -1.01, -2.78]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.1, -0.92, 0.66]}
        rotation={[-0.61, -0.12, -2.95]}
        scale={0}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.08, -0.92, 0.66]}
        rotation={[-0.62, -0.08, -2.95]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.14, -0.91, 0.66]}
        rotation={[-0.32, -1.01, -2.78]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.85, 0.5, 0.57]}
        rotation={[0.77, -0.19, -0.87]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.78, 0.5, 0.65]}
        rotation={[0.79, -0.21, -0.7]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.94, 0.34, 0.55]}
        rotation={[0.77, -0.19, -0.87]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[-1.13, 0, -0.15]}
        rotation={[0.93, -0.17, 1.64]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[-1.06, -0.08, -0.41]}
        rotation={[0.94, -0.21, 2]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[-1.03, -0.16, -0.44]}
        rotation={[0.94, -0.21, 2]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[-1.02, -0.24, -0.44]}
        rotation={[0.88, -0.07, 1.93]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[-0.97, -0.43, -0.13]}
        rotation={[0.77, 0.18, 1.97]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane.geometry} material={materials.Wood} />
        <mesh geometry={nodes.Plane_1.geometry} material={materials.Tree} />
      </group>
      <group
        position={[0.44, 0.87, 0.59]}
        rotation={[-2.28, -0.8, -2.63]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.16, 1.02, 0.27]}
        rotation={[-2.52, -0.88, -2.81]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.25, 1.03, 0.11]}
        rotation={[-2.65, -0.91, -2.75]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.28, 0.98, 0.32]}
        rotation={[-2.52, -0.88, -2.81]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[-0.64, 0.56, 0.65]}
        rotation={[-3.04, -0.68, 2.23]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.86, 0.63, 0.39]}
        rotation={[-1.84, -0.59, -2.09]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.94, 0.62, 0.17]}
        rotation={[-1.99, -0.52, -1.89]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.93, 0.54, 0.36]}
        rotation={[-1.73, -0.43, -2.05]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.8, 0.75, 0.31]}
        rotation={[-1.84, -0.59, -2.09]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.86, 0.74, 0.07]}
        rotation={[-2.02, -0.59, -2.02]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.88, 0.66, 0.29]}
        rotation={[-1.83, -0.59, -2.08]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.81, 0.47, -0.64]}
        rotation={[-1.84, -0.58, -1.12]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.69, 0.43, -0.79]}
        rotation={[-2.03, -0.82, -1.18]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.91, 0.36, -0.58]}
        rotation={[-1.83, -0.58, -1.11]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[-0.08, -0.68, 0.9]}
        rotation={[-0.88, -0.04, 3.07]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.13, -0.8, 0.8]}
        rotation={[-0.97, 0.61, -2.86]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.01, -0.8, 0.81]}
        rotation={[-0.87, 0.07, 3.07]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.03, -0.71, 0.88]}
        rotation={[-0.93, 0.04, -3.04]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.06, -0.76, 0.84]}
        rotation={[-0.93, 0.03, -3.04]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.14, -0.85, 0.77]}
        rotation={[-0.71, 1.46, -3.02]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.05, -0.93, 0.66]}
        rotation={[2.77, 0.93, -0.32]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.06, -0.85, 0.76]}
        rotation={[-2.73, 1.55, -1]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.18, -0.86, 0.71]}
        rotation={[-2.36, 1.38, -1.42]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.12, -0.88, 0.7]}
        rotation={[-2.27, 1.38, -1.51]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.88, 0.36, 0.61]}
        rotation={[-1.69, -0.37, -2.2]}
        scale={0}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[-1.1, 0.03, -0.29]}
        rotation={[2.91, 0.14, 1.7]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[-0.98, -0.38, -0.43]}
        rotation={[2.92, 0.37, 1.29]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[-0.95, -0.3, -0.56]}
        rotation={[2.98, 0.64, 1.48]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane001.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane001_1.geometry}
          material={materials["Autumm orange"]}
        />
      </group>
      <group
        position={[0.45, 0.9, 0.52]}
        rotation={[-2.64, -0.07, -2.79]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane002.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane002_1.geometry}
          material={materials["Autumm yellow"]}
        />
      </group>
      <group
        position={[0.23, 1, 0.29]}
        rotation={[-2.76, -0.1, -2.93]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane002.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane002_1.geometry}
          material={materials["Autumm yellow"]}
        />
      </group>
      <group
        position={[-0.6, 0.57, 0.68]}
        rotation={[-2.43, -0.1, 2.48]}
        scale={0}
      >
        <mesh geometry={nodes.Plane002.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane002_1.geometry}
          material={materials["Autumm yellow"]}
        />
      </group>
      <group
        position={[0.91, 0.58, 0.37]}
        rotation={[-2.5, 0.07, -2.21]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane002.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane002_1.geometry}
          material={materials["Autumm yellow"]}
        />
      </group>
      <group
        position={[0.85, 0.7, 0.29]}
        rotation={[-2.68, -0.17, -2.28]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane002.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane002_1.geometry}
          material={materials["Autumm yellow"]}
        />
      </group>
      <group
        position={[0.86, 0.3, -0.67]}
        rotation={[-2.97, -0.65, -1.66]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane002.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane002_1.geometry}
          material={materials["Autumm yellow"]}
        />
      </group>
      <group
        position={[0, -0.77, 0.83]}
        rotation={[-0.78, 0.97, 3.02]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane002.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane002_1.geometry}
          material={materials["Autumm yellow"]}
        />
      </group>
      <group
        position={[0.05, -0.74, 0.86]}
        rotation={[-1.08, 1, -2.96]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane002.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane002_1.geometry}
          material={materials["Autumm yellow"]}
        />
      </group>
      <group
        position={[-0.01, -0.88, 0.72]}
        rotation={[2.57, 0.66, -0.02]}
        scale={0.01}
      >
        <mesh geometry={nodes.Plane002.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane002_1.geometry}
          material={materials["Autumm yellow"]}
        />
      </group>
      <group
        position={[0.32, -0.77, 0.76]}
        rotation={[2.5, 0.6, -0.28]}
        scale={0}
      >
        <mesh geometry={nodes.Plane002.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane002_1.geometry}
          material={materials["Autumm yellow"]}
        />
      </group>
      <group
        position={[-1.11, 0.03, -0.25]}
        rotation={[-2.57, 0.19, 1.56]}
        scale={0}
      >
        <mesh geometry={nodes.Plane002.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane002_1.geometry}
          material={materials["Autumm yellow"]}
        />
      </group>
      <group
        position={[-0.95, -0.37, -0.51]}
        rotation={[-2.52, 0.31, 0.92]}
        scale={0}
      >
        <mesh geometry={nodes.Plane002.geometry} material={materials.Wood} />
        <mesh
          geometry={nodes.Plane002_1.geometry}
          material={materials["Autumm yellow"]}
        />
      </group>
    </group>
  );
}

useGLTF.preload("/planet-transformed.glb");
